<template>
    <div class="zhzf">
        <div class="zhzfcontent">
            <van-field v-model="zfzlist.stationName" label="工作站名称" placeholder="暂无" input-align="right"  readonly/>
            <van-field v-model="zfzlist.villageNames" label="管辖小区" placeholder="暂无" input-align="right"  readonly/>
            <van-field v-model="zfzlist.workIntro" type="textarea" label="工作职责" placeholder="暂无" input-align="right"  readonly/>
            <div class="monicell">
                <div class="zz">
                    <div class="zctitle">
                        <span>人员列表</span>
                    </div>
                </div>
            </div>
            <div class="ryitem" v-for="(item, index) in zfzlist.members" :key="index">
                <img :src="item.photo" alt="" />
                <div class="zi">
                    <div class="zileft">
                        <span class="style1">{{ item.name }}</span>
                        <!-- <span>所在小区：{{ item.villageName }}</span> -->
                    </div>
                    <div class="ziright">
                        <span>电话：{{ item.phone }}</span>
                        <span>单位：{{ item.workDept }}</span>
                    </div>
                </div>
            </div>
            <div class="fujian" v-show="doclist.length>0">
                <div class="fjtitle">
                    <span>附件列表</span>
                </div>
                <a class="xiazai disac" download="text" :href="item.webUrl" v-for="(item,index) in zfzlist.attachList" :key="index">
                    <span>{{item.fileName}}</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            finished: false,
            defaultimg: require('../assets/wyjj/tx.png'),
            ifsrc:'',
            zfzlist:{
                name:'执法站1',
                xq:'小区1',
                duty:'职责1'
            },
            doclist:[
                {
                    name:'附件1',
                    src:'附件1.doc'
                }
            ],
            list:[
                {
                    employeesName:'张三',
                    employeesPhone:'123214213213',
                    address:'江阴市'
                }
            ]
        }
    },
    mounted() {
        this.getdata()
    },
    methods: {
        getdata(){
            this.$axios.get('/api/v1/workstation/view',{
                params:{
                    id:this.$route.query.id
                }
            }).then(result=>{
                this.zfzlist = result
            })
        }

    },
}
</script>
<style lang="less" scoped>
    .zhzf{
        height: 100%;
        width: 100%;
        .zhzfcontent{
            height: 100%;
            width: 92%;
            margin-left:4%;
            .fujian{
                display: flex;
                flex-direction: column;
                .fjtitle{
                    height: 24px;
                    width: 100%;
                    font-size: 18px;
                    border-left: 4px solid #28aff6;
                    display: flex;
                    align-items: center;
                    position: relative;
                    span {
                    margin-left: 10px;
                    }
                }
                .xiazai{
                    margin-top: 10px;
                }
            }
            .ryitem {
				width: 100%;
				height: 80px;
				display: flex;
				align-items: center;
				border-radius: 10px;
				box-shadow: 0 0 10px #dadada;
				margin-bottom: 20px;

				img {
					margin-left: 20px;
					height: 50px;
					width: 50px;
				}

				.zi {
					margin-left: 20px;
					height: 80%;
					display: flex;
					justify-content: space-between;
					font-size: 13px;
					width: 100%;
					.zileft,
					.ziright {
						display: flex;
						flex-direction: column;
						justify-content: center;
						width: 50%;
					}
					.ziright{
						color: #999;
					}
				}

				.style1 {
					font-size: 16px;
				}
			}
            .monicell{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .zz{
                    margin:10px 16px;
                    width:100%;
                    display: flex;
                }
                .zctitle{
                    width: 40%;
                    color: #646566;
                    font-size: 14px;
                }
                .srfw{
                    font-size: 14px;
                    width: 60%;
                    display: flex;
                    justify-content: flex-end;
                    white-space: pre-wrap;
                }
            }
        }
        
    }
</style>